__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-rewards/v2_2_2/";